import { useState, useEffect } from 'react';
import jwt_decode from "jwt-decode";
import { useAuth } from "../auth/useAuth.js";

const OLD_TOKEN = 'https://api.houm.com/old_token';

/**
 * Access token for calls to ms-accounting.
 *
 * Returns "" until the session resolves, so the ~11 screens that pass it to
 * `getBaseHeaders(token)` keep the same contract they had under Auth0.
 */
export const useAuthToken = () => {
    const [authToken, setAuthToken] = useState('');
    const { getAccessToken, isAuthenticated } = useAuth();

    useEffect(() => {
        let cancelled = false;
        (async () => {
            if (!isAuthenticated) return;
            try {
                const token = await getAccessToken();
                if (!cancelled) setAuthToken(token || '');
            } catch (e) {
                console.error(e);
            }
        })();
        return () => { cancelled = true; };
    }, [getAccessToken, isAuthenticated]);

    return authToken;
}

export const getOldToken = (authToken) => {
    let jwt_decoded = jwt_decode(authToken);
    return jwt_decoded[OLD_TOKEN];
}
